import { Toaster } from 'sonner'

import { growlCompat } from '../../utils/toast'

window.growl = growlCompat

export const Growl = () => (
  <Toaster
    position="top-right"
    richColors
    toastOptions={{
      style: {
        marginTop: 50,
        fontFamily: 'var(--font-family)',
        borderRadius: 'var(--radius-md)',
        border: '1px solid var(--border)',
        boxShadow: 'var(--shadow-lg)'
      }
    }}
  />
)
